// src/components/auth/RequireAuth.tsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthProvider";

export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm tracking-widest">
        LOADING
      </div>
    );
  }

  // ✅ chưa login -> chuyển sang /auth và nhớ "from"
  if (!user) {
    const from = location.pathname + location.search;

    return (
      <Navigate
        to="/auth?tab=login"
        replace
        state={{ from }}
      />
    );
  }

  return <Outlet />;
}
